import BaseDeliveryRoute from 'cio/routes/base-delivery';
export default BaseDeliveryRoute;
